export default {
      id: "crosshairs-solid-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#crosshairs-solid",
      toString: function () {
        return this.url;
      }
    }